import { Box } from 'theme-ui';
import { Flex } from '@lib/ui';

export default function Panel({ children, sx = {}, transparent = false, label, fullWidth  = false, ...props}) {
  return (
    <Flex
      inline={!fullWidth}
      direction="column"
      sx={{
        border: transparent ? undefined : '1px solid #aaa',
        borderRadius: '4px',
        ...sx
      }}
      {...props}
    >
      <Box
        sx={{
          fontWeight: 600,
          px: transparent ? undefined : 2,
          py: 1,
          borderBottom: '1px solid #aaa',
          borderRadius: '4px 4px 0 0',
          backgroundColor: transparent ? undefined : '#efe8e3',
          display: 'inline-flex',
          alignItems: 'center'
        }}
      >
        {label}
      </Box>
      <Box
        px={transparent ? undefined : 2}
        py={2}
        backgroundColor={transparent ? undefined : '#f5f2f1'}
        sx={{
          borderRadius: '0 0 4px 4px',
        }}
      >
        {children}
      </Box>
    </Flex>
  );
}
